import { type PlatformEvent } from '../types';

export const pageLoadEvent = (): PlatformEvent => {
  const start = window.PAGE_LOAD_START || 0;
  const end = window.PAGE_LOAD_END || Date.now();
  const time = Math.max(0, end - start);

  return {
    type: 'page_load_time_mp',
    created: Date.now(),
    user_properties: {},
    event_properties: {
      name: 'page_load_time_mp',
      value: time,
    },
  };
};
